// extracted by mini-css-extract-plugin
var _1 = "BarGraph__canvas--MYNVE";
var _2 = "BarGraph__label--gA4N8";
var _3 = "BarGraph__main--LJh4O";
export { _1 as "canvas", _2 as "label", _3 as "main" }
